import React from 'react';
import {
  ModalOverlay,
  ModalContent,
  Header,
  Title,
  CloseButton,
  Body,
  Label,
  SearchWrapper,
  SearchInput,
  SearchIcon as StyledSearchIcon, // Renomeado para evitar conflito com o import do SVG
  Footer,
  CancelButton,
  ImportButton,
  ImportIcon as StyledImportIcon, // Renomeado para evitar conflito com o import do SVG
} from './Importstyle'; // Certifique-se que './Importstyle' contém os estilos CSS que sugeri no Passo 1

// Certifique-se que esses caminhos estão corretos e as imagens existem
import CloseIcon from '../../../../assets/produtcss/close.svg';
import importIcon from '../../../../assets/produtcss/importtwo.svg';
import searchIcon from '../../../../assets/produtcss/search.svg';


interface ImportPatternModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ImportPatternModal: React.FC<ImportPatternModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <Header>
          <Title>Importar padrão</Title>
          <CloseButton onClick={onClose}>
            <img src={CloseIcon} alt="Fechar" />
          </CloseButton>
        </Header>

        <Body>
          <Label>Selecione o produto</Label>
          <SearchWrapper>
            <SearchInput placeholder="Buscar" />
            {/* O ícone de busca agora é um componente StyledSearchIcon com a imagem correta */}
            <StyledSearchIcon src={searchIcon} alt="Buscar" />
          </SearchWrapper>
        </Body>

        <Footer>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <ImportButton>
            {/* O ícone de importar agora é um componente StyledImportIcon com a imagem correta */}
            <StyledImportIcon src={importIcon} alt="Importar" />
            Importar
          </ImportButton>
        </Footer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ImportPatternModal;